import React, { Fragment } from "react";
import { Input, Radio } from "antd";
import "./TimeSheet.css";

export const DAILY = "daily";
export const WEEKLY = "weekly";
const WorkingHours = ({
  label = "Working hours",
  hourType,
  workingHours,
  handleHourTypeChange,
  handleWorkingHoursChange,
  errorMessage,
}) => {
  const options = [
    { label: "Per Day", value: DAILY },
    { label: "Per Week", value: WEEKLY },
  ];

  return (
    <Fragment>
      <div className="email-text">
        {label}
        <div className="email-mandatory">(Mandatory)</div>
      </div>
      <div style={{ marginTop: "10px" }}>
        <Radio.Group
          style={{ display: "flex", columnGap: "20px" }}
          block
          options={options}
          defaultValue="Per Day"
          value={hourType}
          optionType="button"
          buttonStyle="solid"
          onChange={handleHourTypeChange}
        />
        <Input
          className="working-hr-input"
          value={workingHours}
          type="number"
          min={0}
          status={errorMessage ? "error":""}
          onChange={handleWorkingHoursChange}
          
        />
        {errorMessage ? (
          <div style={{ color: "#ff4d4f", marginTop: 6 }}>{errorMessage}</div>
        ) : null}
      </div>
    </Fragment>
  );
};

export default WorkingHours;
